export default {
  home: {
    'deviceSum': '设备总数',
    'onlineDevice': '在线设备',
    'alarmQuantity': '报警数量',
    'offDevice': '离线设备',
    'deviceList':'设备列表',
    'map':'地图信息',
    'deviceInfo':'设备信息',
    'deviceName':'设备名称',
    'groupId':'组标识',
    'onlineState':'在线状态',
    'deviceOffTime':'离线时间',
    'deviceOnlineTime':'上线时间',
    'createTime': '创建时间',
    'featureInfo':'要素信息',
    'noData': '暂无数据',
    'groupNoDevice': '当前组无设备',
    'offLine': '离线',
    'onLine': '在线',
  },
  arg: {
    'closeDialog':'确定关闭吗?',
    'viewCurve': '查看曲线',
    'historicalData': '历史数据',
    'query': '查询',
    'exportData': '导出数据',
    'noTime': '开始时间和结束时间不能为空',
    'noTimeRange': '时间范围过长',
    'noAtr': '属性不能为空',
  },
  group: {
    'defaultGroup': '默认组',
    'groupList' : '场景列表',
    'inputGroupName': '请输入场景名称',
    'selectGroupState': '请选择场景状态',
    'inputDeviceName': '请输入设备名称',
    'editSuccess': '编辑成功',
    'editFail': '编辑失败',
    'confirmSubmission': '你确认提交吗?',
    'tip': '提示',
    'confirm': '确定',
    'cancel': '取消',
    'addSuccess': '添加成功',
    'addFail': '添加失败',
    'sureDeleteScene' :'Are you sure to delete the current scene?',
    'successDelete':'删除成功',
    'undelete' : '取消删除',
    'search': '搜索',
    'newScene': '新建场景',
    'edit' :'编辑',
    'sceneName': '场景名称',
    'sceneState': '场景状态',
    'usable':'可用',
    'forbidden': '禁用',
    'submit': '提交'
  },
  device: {
    'noteNameTip':'请填写备注名称',
    'noteName': '备注名称',
    'devicename':'设备名称',
    'homeGroup': '归属组',
    'longitude': '经度',
    'latitude':'纬度',
    'deviceNameSearch': '请输入设备名称搜索',
    'equipmentInformation': '设备信息',
    'ProductOwnership': '所属产品',
    'creationTime': '创建时间',
    'operation':'操作'
  },
  alarm: {
    'runningStatus': '运行状态',
    'close':'停止',
    'open':'运行中',
    'handleOpen': '运行',
    'passageway':'通知通道',
    'selectPassageway':'请选择通知通道',
    'alarmRule':'告警规则',
    'searchTitle': '请输入告警标题搜索',
    'add': '新增',
    'edit': '编辑',
    'triggerType':'触发类型',
    'attributeChange': '设备属性变化',
    'deviceOffLine': '设备离线',
    'hitCount': '命中次数',
    'duration':'持续时长',
    'alarmCondition':'告警条件',
    'notRelease':'未发布',
    'haveReleased':'已发布',
    'soldOut':'下架',
    'alarmName':'告警名称',
    'selectDevice':'请选择活动设备',
    'conditionList':'条件列表',
    'and&or': '请选择且，或',
    'attribute': '属性',
    'selectCondition':'请选择条件',
    'delete':'删除',
    'enterContent': '请输入内容',
    'addCondition':'添加条件',
    'alarmLevel':'告警级别',
    'notificationChannel':'通知通道',
    'advancedOptions':'高级选项',
    'manuallyAlarm':'手动解除告警',
    'selectManually':'请选择手动解除告警',
    'startTime':'开始时间',
    'endTime': '结束时间',
    'effectivePeriod': '有效时间段',
    'noTimeSelect':'没有选择时间段',
    'experienceTime':'去体验自定义时间（通知更加灵活）',
    'returnTime':'返回传统时间区间设置',
    'support':'支持',
    'nonsupport':'不支持',
    'notificationPeriod':'通知时间段',
    'general':'普通',
    'significance':'重要',
    'seriousness':'严重',
    'minute':'分钟',
    'second':'秒',
    'time':'次',
    'alarmNameNot':'告警名称不能为空',
    'sourceTypeNot':'数据源类型不能为空',
    'sourceNot': '设备源不能为空',
    'triggerTypeNot':'触发类型不能为空',
    'conditionsNot':'条件列表不能为空',
    'severityNot':'告警级别不能为空',
    'manuallyNot':'是否手动解除告警不能为空',
    'success':'成功',
    'fail':'失败',
    'and':'并且',
    'or':'或',
    'greaterThan':'大于',
    'equalOrGreater':'大于等于',
    'lessThan':'小于',
    'lessEqual':'小于等于',
    'equalTo':'等于',
    'unequalTo':'不等于',
    'selectActiveDevice': '请选择活动设备',
  },
  inform: {
    'warningMessage':'告警信息',
    'pending':'待处理',
    'automaticResolution':'自动解决',
    'manualSolution':'手动解决',
  },
  notification: {
    'notificationChannelName':'通知通道名称',
    'notificationWay':'通知方式',
    'sureDelete':'确定删除吗?',
    'emailEmpty':'邮箱地址不能为空',
    'emailFormat':'邮件地址格式错误',
    'nameEmpty':'通告名称不能为空',
    'typeEmpty':'通告类型不能为空',
    'updateSuccessfully':'更新成功',
    'createdSuccessfully':'创建成功',
    'email':'邮箱',
    'emailAddress':'邮箱地址',
    'phoneMessage':'手机号',
    'invalidPhoneMessage':'无效手机号'
  },
  profile: {
    'enterNickname':'请输入昵称',
    'enterEmail':'请输入邮箱',
    'validEmail':'请输入有效邮箱',
    'enterNumber':'请输入手机号',
    'enterValidNumber':'请输入有效的手机号',
    'modifySuccessfully': '修改成功',
    'failModify':'修改失败',
    'enterOldPassword':'请输入旧密码',
    'enterNewPassword':'请输入新密码',
    'characters':'密码长度不能少于 6 个字符',
    'confirmNewPassword':'请确认新密码',
    'twoPasswordsDifferent':'两次输入的新密码不一致',
    'passwordSuccessfully':'密码修改成功',
    'essentialInformation':'基本信息',
    'failedPassword':'修改密码失败',
    'nickname':'用户昵称',
    'phoneNumber':'用户手机号',
    'userMailbox':'用户邮箱',
    'changePassword':'修改密码',
    'oldPassword':'旧密码',
    'newPassword':'新密码',
    'confirmNewPasswordLabel':'确认新密码',
    'editAvatar':'编辑头像',
    'username':'用户名称',
    'callPhoneNumber': '手机号码',
    'loginTime':'登录时间',
    'myAPP': '我的应用',
    'verificationCode': '验证码',
    'enterVerificationCode': '请输入验证码',
    'bindPhoneNumber': '绑定手机号',
    'updatePhoneNumber': '更新手机号',
    'update': '更新',
    'close': '关闭',
    'open': '开启',
    'applicationName': '应用名称',
    'getCode': '获取验证码',
    'key':'密钥',
    'status': '状态',
    'sureChange': '你确定修改这个？'
  },
  message: {
    'messageTip': '消息',
    'noNewsYet':'暂无消息',
    'markedRead':'已标记已读',
    'notificationMessage': '通知消息',
    'allRead':'全部已读',
    'markRead':'标记已读',
    'read': '已读'
  },
  base:{
    'navigation':'导航',
    'own':'个人中心',
    'help':'需要帮助吗?',
    'helpDesc':'我们可以为您提供以下帮助。',
    'softwareSupport':'物联网技术支持',
    'hardwareSupport':'设备技术支持',
    'essentialInformation': '重要信息'
  },
  routesMenu:{
    'homePage':'首页',
    'data':'数据中心',
    'device':'设备中心',
    'alarm':'告警中心',
    'inform': '告警通知',
    'notification':'通知通道',
    'arrange':'设备编排',
    'me':'个人中心',
    'message':'消息中心'
  },
  login: {
    'userTerms':'用户条款',
    'iAgree': '我同意',
    'captchaSuccess':'验证成功',
    'rememberMe':'记住',
    'captchaFail': '验证码错误',
    'signIn': '登录',
    'welcome': '欢迎使用',
    'company':'邯郸市耘农智慧农业科技有限公司',
    'yantaiCompany': '邯郸研泰进出口有限公司',
      'companyProfile':'<p class="text-white position-relative">\n' +
        '                  我们提供的产品涵盖阳光、空气、土壤、水环境领域，利用无线通讯技术及移动端便捷的操作性服务于客户。提供的传感器数量达数十万级，是业界知名的传感器产品及数字解决方案供应商。\n' +
        '                </p>\n' +
        '                <p class="text-white position-relative">\n' +
        '                  公司秉承“诚信、共融、创新、分享”的文化理念，愿与上下游客户一道为实现“数字中国”国家新时代发展理念，为人类赖以生存的环境提供可靠的监测网络和可持续性保障贡献自己的一份力量！\n' +
        '                </p>',
    'yantaiCompanyProfile' : '<p class="text-white position-relative">\n' + '邯郸研泰进出口有限公司' + '</p>\n' +
      '<p class="text-white position-relative">\n' + '我们的产品涵盖阳光、空气、土壤、水环境等领域，利用无线通信技术、便捷的移动操作服务客户，提供数十万种传感器，是业内知名的传感器产品和数字化解决方案供应商。' + '</p>\n' +
      '<p class="text-white position-relative">\n' + '公司秉承“诚信、融合、创新、共享”的文化理念，愿与上下游客户一道为实现“全球数字化”新时代发展理念贡献力量，为人类赖以生存的环境提供可靠的监测网络和可持续保障！' + '</p>\n'
  },
  site:{
    'yantaiTitle':'研泰',
    'primaryName':'云上田野',
    'name':'物联网(IoT)平台'
  },
  navbar:{
    'businessCaseName':'商业案例',
    'businessCaseUrl':'http://nong-iot.cn/business-case.html',
    'businessConsultingName':'业务咨询',
    'businessConsultingUrl':'http://nong-iot.cn/consult.html',
    'aboutUsName':'关于我们',
    'aboutUsNameUrl':'http://nong-iot.cn/about-us.html',
    'productCenterName':'产品中心',
    'productCenterNameUrl':'http://nong-iot.cn/'
  },
  configurator:{
    'theme': '主题配置',
    'themeOptions':'查看我们支持的主题选项。',
    'sidebarColors':'边栏颜色',
    'sidenavType':'左侧导航栏',
    'sidenavDesc':'模式切换支持浅色、深色两种模式',
    'white':'浅色',
    'dark':'深色',
    'navbarFixed':'导航栏固定',
    'themeSwitching':'浅色 / 深色',
    'quit': '退出'
  },
  element: {
    "空气温度": "空气温度",
    "空气湿度": "空气湿度",
    "大气压强": "大气压强",
    "风速": "风速",
    "风向": "风向",
    "降雨量": "降雨量",
    "蒸发量": "蒸发量",
    "土壤温度": "土壤温度",
    "土壤湿度": "土壤湿度",
    "土壤EC": "土壤EC",
    "土壤EC2": "土壤EC2",
    "土壤EC3": "土壤EC3",
    "土壤PH": "土壤PH",
    "光照强度": "光照强度",
    "光合有效": "光合有效",
    "总辐射": "总辐射",
    "总辐射累积量": "总辐射累积量",
    "水平辐射": "水平辐射",
    "水平辐射累积量": "水平辐射累积量",
    "斜面辐射": "斜面辐射",
    "斜面辐射累积量": "斜面辐射累积量",
    "散射辐射": "散射辐射",
    "散射辐射累积量": "散射辐射累积量",
    "直接辐射": "直接辐射",
    "直接辐射累积量": "直接辐射累积量",
    "紫外指数": "紫外指数",
    "紫外辐射": "紫外辐射",
    "日照时数": "日照时数",
    "噪声": "噪声",
    "PM2.5": "PM2.5",
    "PM10": "PM10",
    "CO2": "CO2",
    "SO2": "SO2",
    "CO": "CO",
    "O3": "O3",
    "H2S": "H2S",
    "NO2-1": "NO2-1",
    "NO2-2": "NO2-2",
    "叶面温度": "叶面温度",
    "叶面湿度": "叶面湿度",
    "组件温度": "组件温度",
    "露点温度": "露点温度",
    "小时雨量": "小时雨量",
    "24小时雨量": "24小时雨量",
    "连续雨量": "连续雨量",
    "水温": "水温",
    "水PH": "水PH",
    "水EC": "水EC",
    "溶氧": "溶氧",
    "浊度": "浊度",
    "NH3": "NH3",
    "暴晒温度": "暴晒温度",
    "微气象风速": "微气象风速",
    "微气象风向": "微气象风向",
    "设备电压": "设备电压",
    "设备电量": "设备电量",
    "TSP(PM)100": "TSP(PM)100",
    "负氧离子": "负氧离子",
    "流速(多普勒)": "流速(多普勒)",
    "液位(超声)": "液位(超声)",
    "液位(压力)": "液位(压力)",
    "能见度": "能见度",
    "路面状况路面温度": "路面状况路面温度",
    "路面状况积水深度": "路面状况积水深度",
    "路面状况冰厚度": "路面状况冰厚度",
    "路面状况雪厚度": "路面状况雪厚度",
    "路面状况湿滑系数": "路面状况湿滑系数",
    "路面状况路面状态": "路面状况路面状态",
    "GPS东西经": "GPS东西经",
    "GPS经度": "GPS经度",
    "GPS南北纬": "GPS南北纬",
    "GPS纬度": "GPS纬度",
    "TVOC": "TVOC",
    "雨雪报警": "雨雪报警",
    "电池电压": "电池电压",
    "太阳能电压": "太阳能电压",
    "信号强度": "信号强度",
    "果实膨大": "果实膨大",
    "氨氮": "氨氮",
    "水膜厚度": "水膜厚度",
    "土壤硬度": "土壤硬度",
    "蒸腾量": "蒸腾量",
    "EC": "EC",
    "前置冲洗时间": "前置冲洗时间",
    "轮灌间隔": "轮灌间隔",
    "轮灌次数": "轮灌次数",
    "水肥机工作模式": "水肥机工作模式",
    "水肥机状态": "水肥机状态",
    "水泵状态": "水泵状态",
    "PH": "PH",
    "肥泵状态": "肥泵状态",
    "目标EC": "目标EC",
    "目标PH": "目标PH",
    "后置冲洗时间": "后置冲洗时间",
    "主水源瞬时流量": "主水源瞬时流量",
    "主水源累积流量": "主水源累积流量"
  },


};
